import { usePage } from "@inertiajs/react"

const usePathname = (): string => {
  const { url } = usePage()

  // Remove query string and hash
  const [path] = url.split(/[?#]/)

  // Remove trailing slash unless it's just "/"
  return path !== "/" ? path.replace(/\/+$/, "") : "/"
}

export default usePathname
